import * as React from 'react';
type Props = {
  className?: string;
};
export function Box4({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-box4"
      className={className}
    >
      <path
        d="M13.9668 1.50098C14.4613 1.49885 14.9471 1.63368 15.3691 1.8916C15.74 2.11836 16.0493 2.43165 16.2705 2.80371L16.3594 2.9668L16.3623 2.9707L18.2197 6.70312C18.301 6.86613 18.3639 7.03688 18.4102 7.21191C18.422 7.24972 18.4312 7.28853 18.4385 7.32812C18.4785 7.51275 18.4999 7.70155 18.5 7.8916V15.833C18.5 16.5402 18.2188 17.2187 17.7188 17.7188C17.2187 18.2188 16.5402 18.5 15.833 18.5H4.16699C3.45976 18.5 2.78134 18.2188 2.28125 17.7188C1.78117 17.2187 1.50001 16.5402 1.5 15.833V7.89355C1.50003 7.47979 1.59627 7.07129 1.78125 6.70117L3.64746 2.96973L3.64844 2.9668C3.87105 2.52501 4.21231 2.15355 4.63379 1.89453C5.05467 1.6359 5.53923 1.50039 6.0332 1.50098H9.98926C9.99284 1.50094 9.99641 1.5 10 1.5C10.0033 1.5 10.0065 1.50095 10.0098 1.50098L13.9668 1.5V1.50098ZM3.5 8.51074V15.833C3.50001 16.0098 3.57031 16.1797 3.69531 16.3047C3.82034 16.4297 3.99019 16.5 4.16699 16.5H15.833C16.0098 16.5 16.1797 16.4297 16.3047 16.3047C16.4297 16.1797 16.5 16.0098 16.5 15.833V8.51074H3.5ZM6.03125 3.5C5.90761 3.49978 5.786 3.5339 5.68066 3.59863C5.57637 3.66278 5.49119 3.75426 5.43555 3.86328L5.43652 3.86426L4.11328 6.51074H9V3.5H6.03125ZM11 6.51074H15.8896L14.5732 3.86621C14.5174 3.75554 14.432 3.66234 14.3262 3.59766C14.2202 3.53287 14.0979 3.49914 13.9736 3.5H11V6.51074Z"
        fill="currentColor"
      />
    </svg>
  );
}
